import { useSelector } from "react-redux";
import { Flex, Text, VerticalDivider } from "@100mslive/roomkit-react";
import { Logo, SpeakerTag } from "./HeaderComponents";

export const ConferencingHeader = ({ isPreview }) => {
  const roomName = useSelector(state => state.counter.roomName);

  return (
    <Flex
      justify="between"
      align="center"
      css={{ position: "relative", height: "100%" }}
    >
      <Flex align="center" css={{ position: "absolute", left: "$10" }}>
        <Logo />
        <Text css={{ ml: "$4", fontWeight: "bold" }}>
          {roomName?.name || "HODO"}
        </Text>
        <VerticalDivider css={{ ml: "$8" }} />
        {!isPreview ? <SpeakerTag /> : null}
      </Flex>
    </Flex>
  );
};
